import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  APPOINTMENT_BEFORE_CARE_DOCTOR_CONSULT_PATH,
  APPOINTMENT_BEFORE_CARE_PATH,
  APPOINTMENT_BREAST_CANCER_FORM_PATH,
  APPOINTMENT_BREAST_CANCER_FORM_SUCCESS_PATH,
  APPOINTMENT_CERVICAL_CANCER_FORM_PATH,
  APPOINTMENT_CERVICAL_CANCER_FORM_SUCCESS_PATH,
  APPOINTMENT_DEDICATED_ATTENTION_PATH,
  APPOINTMENT_FV_CONFIRMATION_PATH,
  APPOINTMENT_FV_FAILURE_PATH,
  APPOINTMENT_FV_REFERRAL_SELECTION_PATH,
  APPOINTMENT_FV_SELECT_DOCTOR_PATH,
  APPOINTMENT_FV_SLOT_SELECTION_PATH,
  APPOINTMENT_FV_SUCCESS_PATH,
  APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH,
  APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH,
  APPOINTMENT_MAKE_NEW_AODTH_AVAILABLE_SLOT_PATH,
  APPOINTMENT_MAKE_NEW_AODTH_CONFIRM_PATH,
  APPOINTMENT_MAKE_NEW_AODTH_PATH,
  APPOINTMENT_MAKE_NEW_AODTH_SUCCESS_PATH,
  APPOINTMENT_MAKE_NEW_AUTOGEN_SLOT_CONFIRM_PATH,
  APPOINTMENT_MAKE_NEW_AUTOGEN_SLOT_SELECTION_PATH,
  APPOINTMENT_MAKE_NEW_BOOK_INSTITUTE_SPECIALTY_PATH,
  APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH,
  APPOINTMENT_MAKE_NEW_BOOK_TELECONSULTATION_PATH,
  APPOINTMENT_MAKE_NEW_CONFIRM_PATH,
  APPOINTMENT_MAKE_NEW_DOCTOR_CONSULT_SLOT_SELECTION_PATH,
  APPOINTMENT_MAKE_NEW_DOCTOR_CONSULT_URTI_PATH,
  APPOINTMENT_MAKE_NEW_FAILURE_PATH,
  APPOINTMENT_MAKE_NEW_PATH,
  APPOINTMENT_MAKE_NEW_PREFERRED_POLYCLINIC_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_AUTOGEN_LOCATION_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_DOCTOR_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_LOCATION_DOCTOR_CONSULT_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_LOCATION_PATH,
  APPOINTMENT_MAKE_NEW_SELECT_SERVICE_TYPE_PATH,
  APPOINTMENT_MAKE_NEW_SUCCESS_PATH,
  APPOINTMENT_MAKE_NEW_TELECONSULTATION_AODTH_PATH,
  APPOINTMENT_MAKE_NEW_TELECONSULTATION_PROVIDER_PATH,
  APPOINTMENT_MAKE_NEW_TELECONSULTATION_SERVICE_TYPE_PATH,
  APPOINTMENT_PATH,
  APPOINTMENT_PRECHECKPAGE_PATH,
  APPOINTMENT_TRIAGE_QUESTIONNAIRE_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import { WogaaTrackingSettings } from '@shared/constants/systemSettingsKey';
import type { RouteConfig } from '@shared/types/common.types';

const BeforeCarePage = lazy(() => import('./pages/BeforeCarePage/BeforeCarePage'));
const BookPolyclinicAppointmentPage = lazy(
  () => import('./pages/BookPolyclinicAppointmentPage/BookPolyclinicAppointmentPage')
);
const BreastCancerRequestFormPage = lazy(
  () => import('./pages/BreastCancerRequestFormPage/BreastCancerRequestFormPage')
);
const CervicalCancerRequestFormPage = lazy(
  () => import('./pages/CervicalCancerRequestFormPage/CervicalCancerRequestFormPage')
);
const DoctorSelectionPage = lazy(() => import('./pages/DoctorSelectionPage/DoctorSelectionPage'));
const HealthCareInstitutionSelectionPage = lazy(
  () => import('./pages/HealthCareInstitutionSelectionPage/HealthCareInstitutionSelectionPage')
);
const DoctorConsultLocationSelectionPage = lazy(
  () => import('./pages/DoctorConsultLocationSelectionPage/DoctorConsultLocationSelectionPage')
);
const DoctorConsultBeforeCarePage = lazy(
  () => import('./pages/DoctorConsultBeforeCarePage/DoctorConsultBeforeCarePage')
);
const DoctorConsultSlotSelectionPage = lazy(
  () => import('./pages/DoctorConsultSlotSelectionPage/DoctorConsultSlotSelectionPage')
);
const DoctorConsultUrtiPage = lazy(() => import('./pages/DoctorConsultUrtiPage/DoctorConsultUrtiPage'));
const FvDoctorSelectionPage = lazy(() => import('./pages/FvDoctorSelectionPage/FvDoctorSelectionPage'));

const FvAvailableSlotSelectionPage = lazy(
  () => import('./pages/FvAvailableSlotSelectionPage/FvAvailableSlotSelectionPage')
);
const FvConfirmationPage = lazy(() => import('./pages/FvConfirmationPage/FvConfirmationPage'));

const FvMakeNewSuccessPage = lazy(
  () => import('./pages/SocInstitutionMakeNewSuccessPage/SocInstitutionMakeNewSuccessPage')
);

const FvMakeNewFailurePage = lazy(
  () => import('./pages/SocInstitutionMakeNewFailurePage/SocInstitutionMakeNewFailurePage')
);

const AutogenLocationSelectionPage = lazy(
  () => import('./pages/AutogenLocationSelectionPage/AutogenLocationSelectionPage')
);

const BookInstituteSpecialtyPage = lazy(() => import('./pages/BookInstituteSpecialtyPage/BookInstituteSpecialtyPage'));

const LocationSelectionPage = lazy(() => import('./pages/LocationSelectionPage/LocationSelectionPage'));
const DedicatedAttentionPage = lazy(() => import('./pages/DedicatedAttentionPage/DedicatedAttentionPage'));
const MakeNewFailurePage = lazy(() => import('./pages/MakeNewFailurePage/MakeNewFailurePage'));
const MakeNewSuccessPage = lazy(() => import('./pages/MakeNewSuccessPage/MakeNewSuccessPage'));
const NewSlotConfirmationPage = lazy(() => import('./pages/NewSlotConfirmationPage/NewSlotConfirmationPage'));
const PreferredPolyclinicPage = lazy(() => import('./pages/PreferredPolyclinicPage/PreferredPolyclinicPage'));
const ServiceTypeSelectionPage = lazy(() => import('./pages/ServiceTypeSelectionPage/ServiceTypeSelectionPage'));
const BookTeleConsultationPage = lazy(() => import('./pages/BookTeleConsultationPage/BookTeleConsultationPage'));
const TeleConsultServiceTypeSelectionPage = lazy(
  () => import('./pages/TeleConsultServiceTypeSelectionPage/TeleConsultServiceTypeSelectionPage')
);
const TeleConsultProviderSelectionPage = lazy(
  () => import('./pages/TeleConsultProviderSelectionPage/TeleConsultProviderSelectionPage')
);
const ScreeningRequestFormSuccessPage = lazy(
  () => import('./pages/ScreeningRequestFormSuccessPage/ScreeningRequestFormSuccessPage')
);
const TriageQuestionnaireRegistrationPage = lazy(
  () => import('./pages/TriageQuestionnaireRegistrationPage/TriageQuestionnaireRegistrationPage')
);
const AodthPage = lazy(() => import('./pages/AodthPage/AodthPage'));
const AodthAvailableSlotSelectionPage = lazy(
  () => import('./pages/AodthAvailableSlotSelectionPage/AodthAvailableSlotSelectionPage')
);
const AodthNewSlotConfirmationPage = lazy(() => import('./pages/AodthNewSlotConfirmationPage'));
const AodthMakeNewSuccessPage = lazy(() => import('./pages/AodthMakeNewSuccessPage'));
const AutogenSlotSelectionPage = lazy(() => import('./pages/AutogenSlotSelectionPage/AutogenSlotSelectionPage'));
const AutogenSlotConfirmationPage = lazy(
  () => import('./pages/AutogenSlotConfirmationPage/AutogenSlotConfirmationPage')
);

const OTPRequestFormPage = lazy(() => import('./pages/HASRequestForm/OTPRequestFormPage/OTPRequestFormPage'));
const PatientContactDetailsPage = lazy(
  () => import('./pages/HASRequestForm/PatientDetailFormPage/PatientContactDetailsPage')
);

const ReferralSourceSelectionPage = lazy(
  () => import('./pages/ReferralSourceSelectionPage/ReferralSourceSelectionPage')
);

const PreCheckPage = lazy(() => import('./pages/PreCheckPage/PreCheckPage'));

export const APPOINTMENT_NEW_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <HealthCareInstitutionSelectionPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.makeNewAppointment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_MAKE_NEW_PATH,
    component: () => <BookPolyclinicAppointmentPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'start', settingKey: WogaaTrackingSettings.MakeNewAppointment },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_MAKE_NEW_PATH,
    component: () => <BookInstituteSpecialtyPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_BOOK_INSTITUTE_SPECIALTY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <ServiceTypeSelectionPage />,
    displayTitle: () => 'Select Service Type',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_SELECT_SERVICE_TYPE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookTeleConsultationPage />,
    displayTitle: () => 'New Tele-Consultation',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_BOOK_TELECONSULTATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <TeleConsultServiceTypeSelectionPage />,
    displayTitle: () => 'Select Service Type',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_TELECONSULTATION_SERVICE_TYPE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <TeleConsultProviderSelectionPage />,
    displayTitle: () => 'Select Provider',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_TELECONSULTATION_PROVIDER_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <LocationSelectionPage />,
    displayTitle: () => 'Select Location',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_SELECT_LOCATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <DoctorSelectionPage />,
    displayTitle: () => 'Select Doctor',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_SELECT_DOCTOR_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <TriageQuestionnaireRegistrationPage />,
    displayTitle: () => 'Registration',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_TRIAGE_QUESTIONNAIRE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <DedicatedAttentionPage />,
    displayTitle: () => 'Registration',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_DEDICATED_ATTENTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BreastCancerRequestFormPage />,
    displayTitle: () => 'Breast Cancer (Mammogram) Screening Request Form',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BREAST_CANCER_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'start', settingKey: WogaaTrackingSettings.BreastCancerScreening },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <CervicalCancerRequestFormPage />,
    displayTitle: () => 'Cervical Cancer Screening Form',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_CERVICAL_CANCER_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'start', settingKey: WogaaTrackingSettings.CervicalCancerScreening },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <NewSlotConfirmationPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <MakeNewSuccessPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.MakeNewAppointment },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <MakeNewFailurePage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_FAILURE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <ScreeningRequestFormSuccessPage />,
    displayTitle: () => 'Cervical Cancer Screening Form',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_CERVICAL_CANCER_FORM_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.CervicalCancerScreening },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <ScreeningRequestFormSuccessPage />,
    displayTitle: () => 'Breast Cancer (Mammogram)Screening Request Form',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BREAST_CANCER_FORM_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.BreastCancerScreening },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH,
    component: () => <BeforeCarePage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BEFORE_CARE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <PreferredPolyclinicPage />,
    displayTitle: () => 'Setup Preferred Polyclinics',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_PREFERRED_POLYCLINIC_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH,
    component: () => <AodthPage />,
    displayTitle: () => 'Video Consult',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_AODTH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <AodthPage />,
    displayTitle: () => 'Video Consult',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_TELECONSULTATION_AODTH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_MAKE_NEW_AODTH_PATH,
    component: () => <AodthAvailableSlotSelectionPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_AODTH_AVAILABLE_SLOT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_MAKE_NEW_AODTH_AVAILABLE_SLOT_PATH,
    component: () => <AodthNewSlotConfirmationPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_AODTH_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <AodthMakeNewSuccessPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_AODTH_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.MakeNewAppointment },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <AutogenSlotSelectionPage />,
    displayTitle: () => 'New Appointment',
    isHideBackNavButton: true,
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_AUTOGEN_SLOT_SELECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <AutogenSlotConfirmationPage />,
    displayTitle: () => 'New Appointment',
    isHideBackNavButton: true,
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_AUTOGEN_SLOT_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <DoctorConsultUrtiPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_DOCTOR_CONSULT_URTI_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <DoctorConsultLocationSelectionPage />,
    displayTitle: () => 'Select Location',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_SELECT_LOCATION_DOCTOR_CONSULT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <DoctorConsultBeforeCarePage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BEFORE_CARE_DOCTOR_CONSULT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <DoctorConsultSlotSelectionPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_DOCTOR_CONSULT_SLOT_SELECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.MOBILE],
    actionUrl: ACTION_BACK_PATH,
    component: () => <AutogenLocationSelectionPage />,
    displayTitle: () => 'Select Location',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_SELECT_AUTOGEN_LOCATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.tcuAppointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <OTPRequestFormPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <PatientContactDetailsPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <ReferralSourceSelectionPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_FV_REFERRAL_SELECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <FvDoctorSelectionPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_FV_SELECT_DOCTOR_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <FvAvailableSlotSelectionPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_FV_SLOT_SELECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <FvConfirmationPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_FV_CONFIRMATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <FvMakeNewSuccessPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_FV_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.MakeNewAppointment },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <FvMakeNewFailurePage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_FV_FAILURE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <PreCheckPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_PRECHECKPAGE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
